/** @file Resolves a mesh attachment inside a command draft (VALIDATION when the target is a region). */
import type { Draft } from 'immer';
import type { AttachmentDoc, Doc, Id, MeshAtt } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';

/** The id and mutable record of mesh `target` (name or id); NOT_FOUND when missing, VALIDATION at `target` for a region. */
export function meshDraft(draft: Draft<Doc>, ctx: CommandContext, target: string): { id: Id; mesh: MeshAtt } {
  const id = ctx.resolve('attachment', target);
  const att: AttachmentDoc | undefined = draft.attachments[id];
  if (att === undefined) return throwError('NOT_FOUND', { kind: 'attachment', ref: target });
  if (att.type !== 'mesh') return throwError('VALIDATION', undefined, { path: 'target', hint: `attachment ${att.name} is a region; mesh commands need a mesh attachment` });
  return { id, mesh: att };
}
